import React, { useEffect, useState } from "react";
import NoDataFound from "../../common/NoDataFound";
import NextImage from "../../common/NextImage";
import { postType } from "../../../utils/constants";
import SocialPost from "./SocialPost";
import NormalPost from "./NormalPost";

const Commentary = ({ data, id, title, baseUrl }) => {
  const [extraItems, setExtraItems] = useState([]);
  const [extraMeta, setExtraMeta] = useState(null);
  const [pageCount, setPageCount] = useState(1);
  const [loading, setLoading] = useState(false);
  const [matchDetail, setMatchDetail] = useState(null);

  // Derive the full commentary by merging prop data with incrementally loaded items
  const commentary = extraMeta
    ? { data: [...(data?.data || []), ...extraItems], metadata: extraMeta }
    : data;

  useEffect(() => {
    const fetchMatchDetail = async () => {
      try {
        const res = await fetch(`${baseUrl}/football/match/${id}/detail`, {
          headers: {
            Token: process.env.REACT_APP_API_TOKEN,
          },
        });
        if (!res.ok) throw new Error(res?.statusText);
        const json = await res?.json();
        setMatchDetail(json);
      } catch (err) {
        console.error("Failed to load match detail:", err);
      }
    };

    if (id && baseUrl) {
      fetchMatchDetail();
    }
  }, [id, baseUrl]);

  const handleLoadMore = async () => {
    const nextPage = pageCount + 1;
    setLoading(true);
    try {
      const res = await fetch(
        `${baseUrl}/football/match/${id}/commentary?page=${nextPage}`,
        {
          headers: {
            Token: process.env.REACT_APP_API_TOKEN,
          },
        }
      );
      if (!res.ok) throw new Error(res?.statusText);

      const json = await res?.json();

      setExtraItems((prev) => [...prev, ...(json?.data || [])]);
      setExtraMeta(json?.metadata);
      setPageCount(nextPage);
    } catch (err) {
      console.error("Failed to load more commentary:", err);
    } finally {
      setLoading(false);
    }
  };

  const displayCard = (commentHtml, type) => {
    if (type === "sub") {
      return (
        <NextImage
          src={`${process.env.REACT_APP_BASE_URL}/public/assets/images/svg/double-arrow.svg`}
          width={16}
          height={16}
          alt="substitution"
        />
      );
    }

    let icon = "";
    if (type === "goal") icon = "footbal-ico";
    if (type === "card") {
      if (commentHtml?.includes("yellow")) icon = "card-yellow";
      if (commentHtml?.includes("red")) icon = "card-red";
    }

    return (
      <NextImage
        src={`${process.env.REACT_APP_BASE_URL}/public/assets/images/svg/${icon}.svg`}
        width={16}
        height={16}
        alt={type}
      />
    );
  };

  const rows = commentary?.data || [];
  const finishTime = matchDetail?.data?.f_time;
  const timeOnly = finishTime?.split(" ")[1]?.slice(0, 5) || finishTime;

  return (
    <>
      {title && <h1>{title}</h1>}
      {rows?.length ? (
        <div className="commentary_wrp">
          <ul className="commentary_lst">
            {rows.map((c) => (
              <li key={c.id}>
                {c?.type === postType?.twitter ? (
                  <SocialPost
                    commentaryData={c}
                    timeOnly={timeOnly}
                  />
                ) : (
                  <NormalPost
                    commentaryData={c}
                    timeOnly={timeOnly}
                    displayCard={displayCard}
                  />
                )}
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <NoDataFound />
      )}

      {commentary?.metadata?.pagination?.last_page > pageCount && (
        <div className="text_center">
          <button
            className="button button_primary"
            onClick={() => handleLoadMore()}
            disabled={loading}
          >
            {loading ? "Loading..." : "See More"}
          </button>
        </div>
      )}
    </>
  );
};

export default Commentary;
